SCM.ArticleListNewAndPopular = (function () {

    return {
        registerArticleListNewAndPopularCombinedMode: registerArticleListNewAndPopularCombinedMode
    };

    // Register click events for ArticleListNewAndPopular widget
    function registerArticleListNewAndPopularCombinedMode() {
        $('.articleListNewAndPopular-mode').each(function () {
            var linkNewAndPopularMode = $(this);
            linkNewAndPopularMode.on('click',
                function (e) {
                    e.preventDefault();
                    $('.articleListNewAndPopular-mode').removeClass('active').attr('aria-pressed', 'false');
                    var mode = linkNewAndPopularMode.data('mode');
                    $('.articleListNewAndPopular-mode[data-mode="' + mode + '"]').addClass('active').attr('aria-pressed', 'true');
                    var articleListNewPopContent = $('.articleListNewAndPopular-ContentView-' + mode);
                    if (!articleListNewPopContent.hasClass('hasContent')) {
                        var widgetInstanceName = getWidgetInstanceName('.widget-ArticleListNewAndPopular');
                        getArticleListNewAndPopularContent(mode, articleListNewPopContent, widgetInstanceName);
                        articleListNewPopContent.addClass('hasContent');
                    }
                    $('section[class*="articleListNewAndPopular-ContentView-"]').hide();
                    articleListNewPopContent.removeClass('hide');
                    articleListNewPopContent.show();
                });
        });
    }

    function getWidgetInstanceName(widgetClass) {
        var widgetInstanceName;
        var className = $(widgetClass).attr('class');
        if (className.indexOf('widget-instance-') >= 0) {
            widgetInstanceName = className.substr(className.indexOf('widget-instance-')).split('-')[2];
        }
        return widgetInstanceName;
    }

    function getArticleListNewAndPopularContent(mode, articleListNewPopContent, widgetName) {
        $.ajax({
            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/PlatformArticle/ArticleListNewAndPopularContent/' + (widgetName.length ? '/' + widgetName : ''),
            cache: false,
            data: {
                mode: mode
            },
            dataType: 'html',
            success: function (data) {
                articleListNewPopContent.html(data);
            }
        });
    }

})();